export const feedbackDataTwo = [
    {
        rating: "/images/icons/stars-5.svg",
        feedback: "Nice. Good opportunity. Good choice to go Ashva Education to learn. Ashwini ma’am is wonderful, helpful, and her teaching style is excellent. You get many job opportunities. I am happy!",
        image: "/images/icons/male.png",
        name: "Arjun",
        designation: "B.Sc-Radiology and Imaging",
    },
    {
        rating: "/images/icons/stars-5.svg",
        feedback: "Excellent Ashva Institute. All teachers are very supportive, especially Ashwini ma’am. Thanks a lot for making my future bright!",
        image: "/images/icons/female.png",
        name: "Divya Pise",
        designation: "B.Sc-Software Development",
    },
    {
        rating: "/images/icons/stars-5.svg",
        feedback: "I am studying DMLT at Ashva Education. It is a very nice college with supportive and warm teachers. One of the best colleges in my life! Thanks to Ashva Education and the teachers for making me a part of this journey.",
        image: "/images/icons/female.png",
        name: "Ananya",
        designation: "Diploma-Radiation Technology",
    },
    {
        rating: "/images/icons/stars-5.svg",
        feedback: "Excellent coaching institute of Paramedical Science with great experience and advanced technology. Ashwini ma’am gives special attention to every student. The teachers are very supportive, and their explanations are outstanding",
        image: "/images/icons/female.png",
        name: "Priya",
        designation: "Diploma-Physiotherapy",
    },
    {
        rating: "/images/icons/stars-5.svg",
          feedback: "Ashva College has a great learning environment with supportive teachers and modern facilities. I really enjoyed my time here and gained a lot of confidence.",
        image: "/images/icons/male.png",
        name: "Rahul Verma",
        designation: "Diploma-Sanitary Inspector",
    },
    {
        rating: "/images/icons/stars-5.svg",
          feedback: "The college not only focuses on studies but also provides opportunities for skill development. The staff is friendly and always ready to help students.",

        image: "/images/icons/male.png",
        name: "Siddharth",
        designation: "Diploma-Pharmacy",
    }
    
]